import React, { Component } from "react";
import { connect } from "react-redux";
import "./signIn.css";
import {
  Collapse,
  Navbar,
  NavbarToggler,
  NavbarBrand,
  Button,
  Form,
  FormGroup,
  FormFeedback,
  Label,
  Input
} from "reactstrap";
import VerificationModal from "../components/verification-modal";
import Joi from "joi-browser";
import { MobileOperatorService } from "../services";
import httpClient from "../http-client/client";
import { Link } from "react-router-dom";
import { ToastContainer, toast, Slide } from "react-toastify";
import { successfullyLogin } from "../redux/actions";
import "react-toastify/dist/ReactToastify.min.css";
const toMysqlFormat = require("../utils/mysqlDateFormat");
const logo = require("../resources/images/logo.png");

class IndexPage extends Component {
  constructor(props) {
    super(props);
    this.mobileOperatorService = new MobileOperatorService();
  }

  state = {
    isOpen: false,
    modal: false,
    operators: [],
    subscriptionTypes: [],
    register: {
      businessName: "",
      mobileNumber: "",
      mobileOperatorId: "",
      userPassword: "",
      subscriptionTypeId: "",
      registerationDate: "",
      confirmPassword: ""
    },
    // use mobileNumber for verfication
    mobileNumber: "",
    mobileOperatorId: "",
    verificatonMessage: "",
    login: {
      userMobileNumber: "",
      _userPassword: ""
    },
    errors: {}
  };

  schema = Joi.object().keys({
    businessName: Joi.string()
      .required()
      .error(errors => {
        return {
          message: "Business Name is required."
        };
      }),
    mobileNumber: Joi.string()
      .required()
      .error(errors => {
        return {
          message: "Mobile Number is required."
        };
      }),
    mobileOperatorId: Joi.string()
      .required()
      .error(errors => {
        return {
          message: "Select Mobile Operator"
        };
      }),
    userPassword: Joi.string()
      .required()
      .error(errors => {
        return {
          message: "Password is required."
        };
      }),
    confirmPassword: Joi.any()
      .valid(Joi.ref("userPassword"))
      .required()
      .error(errors => {
        return {
          message: "دونوں پاس ورڈ آپس میں نہیں ملتے۔ دوبارہ دیں"
        };
      }),
    // .options({ language: { any: { allowOnly: "must match password" } } }),
    subscriptionTypeId: Joi.string()
      .required()
      .error(errors => {
        return {
          message: "Select Subscription Type"
        };
      }),
    registerationDate: Joi.string().allow("")
  });

  loginSchema = Joi.object().keys({
    userMobileNumber: Joi.string()
      .required()
      .error(errors => {
        return {
          message: "Mobile Number is required."
        };
      }),

    _userPassword: Joi.string()
      .required()
      .error(errors => {
        return {
          message: "Password is required."
        };
      })
  });

  componentDidMount() {
    // Get Operators
    this.getOperators();
    // Get Subscription Types
    this.getSubscriptionTypes();
  }

  reset = () => {
    let register = {
      businessName: "",
      mobileNumber: "",
      mobileOperatorId: "",
      userPassword: "",
      subscriptionTypeId: "",
      registerationDate: "",
      confirmPassword: ""
    };

    let errors = {};
    this.setState({ register, errors });
  };

  // toggle Collapse
  toggle = () => {
    this.setState({ isOpen: !this.state.isOpen });
  };

  // Close Modal
  closeModal = () => {
    this.setState({ modal: false });
  };

  //change handler
  handleChange = event => {
    let value = event.target.value;
    let register = { ...this.state.register };
    register[event.target.name] = value;
    this.setState({ register });
  };

  //login change handler
  handleChangeLogin = event => {
    let value = event.target.value;
    let login = { ...this.state.login };
    login[event.target.name] = value;
    this.setState({ login });
  };

  async getOperators() {
    try {
      let { data } = await this.mobileOperatorService.getOperators();
      this.setState({ operators: data["response"] });
    } catch (error) {
      this.setState({ operators: [] });
    }
  }

  async getSubscriptionTypes() {
    try {
      let { data } = await httpClient.get("/subscriptions/types");
      this.setState({ subscriptionTypes: data["response"] });
    } catch (error) {
      this.setState({ subscriptionTypes: [] });
    }
  }

  handleVerfication = async verficationCode => {
    // start verification process
    try {
      let payload = {
        verificationCode: verficationCode,
        mobileNumber: this.state.mobileNumber
      };

      let { data } = await httpClient.put("/user/verify_user", payload);

      if (data["response"]["verificationCodeStatus"] === 1) {
        // user verified move to next screen;
        const AGENT_ROLE_ID = 2;
        // check if user is agent get more info else take it to dashboard
        if (data["response"]["roleId"] === AGENT_ROLE_ID) {
          this.props.history.push("/agents/info");
        } else {
          this.props.history.push("/dashboard");
        }

        toast.success("آپ کے موبائل نمبر کی تصدیق ہو گئی ہے۔ اب آپ دوبارہ لاگ ان کریں۔", {
          position: toast.POSITION.BOTTOM_RIGHT,
          transition: Slide
        });

      } else {
        // user not verified show message
        //this.setState({ verificatonMessage: "111تصدیقی کوڈ غلط ہے" });
        toast.error("تصدیقی کوڈ غلط ہے", {
          position: toast.POSITION.BOTTOM_RIGHT,
          transition: Slide
        });
      }
    } catch (error) {
      // error occur

      toast.error("Oops something went wrong!!!", {
        position: toast.POSITION.BOTTOM_RIGHT,
        transition: Slide
      });
    }
  };

  // sign up validation
  validation() {
    let { error } = Joi.validate(this.state.register, this.schema, {
      abortEarly: false
    });

    // No error found
    if (!error) return null;

    let errors = {};
    error.details.map(err => (errors[err.path[0]] = err["message"]));

    return errors;
  }

  //login validation
  loginValidation() {
    let { error } = Joi.validate(this.state.login, this.loginSchema, {
      abortEarly: false
    });

    // No error found
    if (!error) return null;

    let errors = {};
    error.details.map(err => (errors[err.path[0]] = err["message"]));

    return errors;
  }

  // login handler
  login = async event => {
    event.preventDefault();

    // validation
    let errors = this.loginValidation();
    if (errors) {
      this.setState({ errors });
      return;
    } else {
      this.setState({ errors: {} });
    }

    let { login } = this.state;

    let { userMobileNumber, _userPassword } = login;

    try {
      var { status, data } = await httpClient.post("/user/login", {
        mobileNumber: userMobileNumber,
        userPassword: _userPassword
      });
      if(data["response"]["role"]!=1){
        toast.info("Unauthorized User", {
          position: toast.POSITION.BOTTOM_RIGHT,
          transition: Slide
        });
      }

      if (status === 200 && data["response"]["verificationCodeStatus"] === 1 && data["response"]["role"]==1 ) {
        let login = {
          userMobileNumber: "",
          userPassword: ""
        };

        this.setState({
          login
        });
        let token = data["response"]["token"];
        this.props.successfullyLogin({ token });

        this.props.history.push("/dashboard");
      }
      // user is not verified authorized to access
      else if (
        status === 200 &&
        data["response"]["verificationCodeStatus"] === 0 && data["response"]["role"]==1 
      ) {
        this.setState({
          modal: true,
          mobileNumber: userMobileNumber,
          mobileOperatorId: data["response"]["mobileOperatorId"]
        });
      }
    } catch (error) {
      // error occur

      let { status } = error.response;

      if (status === 400) {
        toast.info("صارف کا موبائل نمبر یا پاس ورڈ درست نہیں ہے۔", {
          position: toast.POSITION.BOTTOM_RIGHT,
          transition: Slide
        });
      } else if (status === 409) {
        toast.info(
          "آپ کا صارف معطل/بلاک ہو چکا ہے۔ اپنے ایجنٹ سے رابطہ کریں۔",
          {
            position: toast.POSITION.BOTTOM_RIGHT,
            transition: Slide
          }
        );
      } else {
        toast.error(" کچھ دیر بعد کوشش کریں _ ہم معزرت خواہ ہیں۔", {
          position: toast.POSITION.BOTTOM_RIGHT,
          transition: Slide
        });
      }
    }
  };

  // Submit handler For Registration
  handleSubmit = async event => {
    event.preventDefault();

    // validation
    let errors = this.validation();
    if (errors) {
      this.setState({ errors });
      return;
    } else {
      this.setState({ errors: {} });
    }

    let { register } = this.state;
    register.registerationDate = toMysqlFormat(new Date());

    try {
      var { status, data } = await httpClient.post("/agent/signup", register);

      if (status === 200) {
        // show verification modal
        this.setState({
          modal: true,
          mobileNumber: this.state.register.mobileNumber,
          mobileOperatorId: data["response"]["mobileOperatorId"]
        });

        this.reset();
      }
    } catch (error) {
      // error occur

      let { status } = error.response;
      if (status === 409) {
        toast.info("یہ موبائل نمبر پہلے سے رجسٹرڈ ہے", {
          position: toast.POSITION.BOTTOM_RIGHT,
          transition: Slide
        });
      } else {
        toast.error("کچھ دیر بعد کوشش کریں _ ہم معزرت خواہ ہیں", {
          position: toast.POSITION.BOTTOM_RIGHT,
          transition: Slide
        });
      }
    }
  };

  render() {
    let { operators, subscriptionTypes, register, errors } = this.state;
    let {
      businessName,
      mobileNumber,
      mobileOperatorId,
      userPassword,
      confirmPassword,
      subscriptionTypeId
    } = register;

    const operatorsList = operators.map(operator => (
      <option key={operator["operator_id"]} value={operator["operator_id"]}>
        {operator["operator_name"].toUpperCase()}
      </option>
    ));

    const subscriptionTypeList = subscriptionTypes.map(subscription => (
      <option
        key={subscription["subscription_type_id"]}
        value={subscription["subscription_type_id"]}
      >
        {subscription["subscription_type_name"].toUpperCase()}
      </option>
    ));

    return (
      <div style={{ backgroundColor: "#f8f9fa" }}>
        {/* Top band */}
        <Navbar color="primary-theme" dark expand="md">
          <div className="container">
            <NavbarBrand href="/">
              <h2>Gmandi</h2>
            </NavbarBrand>
            <NavbarToggler onClick={this.toggle} />
            <Collapse isOpen={this.state.isOpen} navbar>
              <Form className="ml-auto d-flex">
                <FormGroup className=" mb-2 mr-sm-2 mb-sm-0">
                  <Label
                    style={{ color: "white" }}
                    for="MobileNumber"
                    className="mr-sm-3"
                  >
                    موبائل نمبر
                  </Label>
                  <Input
                    type="text"
                    value={this.state.login.userMobileNumber}
                    name="userMobileNumber"
                    id="MobileNumber"
                    placeholder="03xxxxxxxxx"
                    invalid={Boolean(errors["userMobileNumber"])}
                    onChange={this.handleChangeLogin}
                  />
                </FormGroup>
                <FormGroup className=" mb-2 mr-sm-2 mb-sm-0">
                  <Label
                    style={{ color: "white" }}
                    for="examplePassword"
                    className="mr-sm-2"
                  >
                    پاس ورڈ
                  </Label>
                  <Input
                    type="password"
                    name="_userPassword"
                    value={this.state.login._userPassword}
                    id="examplePassword"
                    placeholder="password"
                    invalid={Boolean(errors["_userPassword"])}
                    onChange={this.handleChangeLogin}
                  />

                  <Link to={"/forget-password"} className="ml-1  text-light">
                    پاسورڈ بھول گے
                  </Link>
                </FormGroup>

                <Button
                  style={{ height: "40px", marginTop: "6%" }}
                  onClick={this.login}
                >
                  لاگ اِن
                </Button>
              </Form>
            </Collapse>
          </div>
        </Navbar>

        {/* end top band */}

        {/* Registration form */}
        <div className="container mt-3 ">
          <div className="row">
            <div className="col-sm-6">
              <img src={logo} className="img-fluid rounded h-75" alt="" />
            </div>
            <div className="col-sm-6">
              <h3>ایجنٹ رجسٹر کریں</h3>
              <Form className="row">
                <FormGroup className="col-sm-12 col-md-6">
                  <Label for="exampleSelect">موبائل آپریٹر</Label>
                  <Input
                    type="select"
                    value={mobileOperatorId}
                    name="mobileOperatorId"
                    id="exampleSelect"
                    invalid={Boolean(errors["mobileOperatorId"])}
                    onChange={this.handleChange}
                  >
                    <option value="">Select Operator</option>
                    {operatorsList}
                  </Input>
                  {errors["mobileOperatorId"] && (
                    <FormFeedback>{errors["mobileOperatorId"]}</FormFeedback>
                  )}
                  <small className="form-text text-muted">
                    براہ کرم آپریٹر منتخب کریں۔ تو آپ کوڈ وصول کرسکتے ہیں
                  </small>
                </FormGroup>
                <FormGroup className="col-sm-12 col-md-6">
                  <Label for="bussinessName">موبائل نمبر</Label>
                  <Input
                    value={mobileNumber}
                    name="mobileNumber"
                    placeholder="Mobile Number"
                    invalid={Boolean(errors["mobileNumber"])}
                    onChange={this.handleChange}
                  />
                  {errors["mobileNumber"] && (
                    <FormFeedback>{errors["mobileNumber"]}</FormFeedback>
                  )}
                </FormGroup>
                <FormGroup className="col-sm-12 col-md-6">
                  <Label for="bussinessName">پاس ورڈ</Label>
                  <Input
                    type="password"
                    value={userPassword}
                    name="userPassword"
                    placeholder="Password"
                    invalid={Boolean(errors["userPassword"])}
                    onChange={this.handleChange}
                  />
                  {errors["userPassword"] && (
                    <FormFeedback>{errors["userPassword"]}</FormFeedback>
                  )}
                </FormGroup>
                <FormGroup className="col-sm-12 col-md-6">
                  <Label for="bussinessName">پاس ورڈ دوبارہ دیں</Label>
                  <Input
                    type="password"
                    value={confirmPassword}
                    name="confirmPassword"
                    placeholder="Confirm Password"
                    invalid={Boolean(errors["confirmPassword"])}
                    onChange={this.handleChange}
                  />
                  {errors["confirmPassword"] && (
                    <FormFeedback>{errors["confirmPassword"]}</FormFeedback>
                  )}
                </FormGroup>
                <FormGroup className="col-sm-12">
                  <Label for="bussinessName">کاروبار کا نام</Label>
                  <Input
                    value={businessName}
                    name="businessName"
                    placeholder="Bussiness Name"
                    invalid={Boolean(errors["businessName"])}
                    onChange={this.handleChange}
                  />
                  {errors["businessName"] && (
                    <FormFeedback>{errors["businessName"]}</FormFeedback>
                  )}
                </FormGroup>
                <FormGroup className="col-sm-12 ">
                  <Label for="exampleSelect">ایجنٹ کی قسم</Label>
                  <Input
                    type="select"
                    name="subscriptionTypeId"
                    value={subscriptionTypeId}
                    id="exampleSelect"
                    invalid={Boolean(errors["subscriptionTypeId"])}
                    onChange={this.handleChange}
                  >
                    <option value="">Select Agent Type</option>
                    {subscriptionTypeList}
                  </Input>
                  {errors["subscriptionTypeId"] && (
                    <FormFeedback>{errors["subscriptionTypeId"]}</FormFeedback>
                  )}
                </FormGroup>
                <div className="col-sm-12 mb-5 ">
                  <p>
                    <Link to="#">میں شرائط و ضوابط سے متفق ہوں</Link>
                  </p>
                  <Button
                    className="small "
                    color="success"
                    onClick={this.handleSubmit}
                  >
                    رجسٹر کریں
                  </Button>
                </div>
              </Form>
            </div>
          </div>
        </div>
        {/* End Registration form */}

        {/* verification Modals */}
        {this.state.modal && (
          <VerificationModal
            mobileNumber={this.state.mobileNumber}
            mobileOperatorId={this.state.mobileOperatorId}
            modal={this.state.modal}
            closeModal={this.closeModal}
            verificatonMessage={this.state.verificatonMessage}
            handleVerfication={this.handleVerfication}
          />
        )}
        {/* End verification Modals */}
        {/* footer */}
        {/* toast notifiction */}
        <ToastContainer />
        {/* end footer */}
      </div>
    );
  }
}

const mapStateToProps = state => ({});
const mapDispatchToProps = dispatch => ({
  successfullyLogin: payload => dispatch(successfullyLogin(payload))
});

export default connect(mapStateToProps, mapDispatchToProps)(IndexPage);
